import {
    Card,
    CardContent,
    Typography,
    Box,
    Divider,
    Avatar,
    AvatarGroup,
    Paper,
    Chip,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Liste der Termine für den ausgewählten Tag inkl. Kopfzeile & "+"-Button.
function TerminListe({
    headerRef,
    selectedDate,
    dateFormat,
    showAddButton,
    isSelectedDateInPast,
    onNewTermin,
    termineForSelectedDate,
    nimmtTeil,
    onTerminClick,
}) {
    return (
        <Card
            sx={{
                width: '100%',
                height: '100%',
                backgroundColor: '#1f2937',
                borderRadius: '16px',
            }}
        >
            <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                <Box
                    ref={headerRef}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                    sx={{ overflow: 'hidden' }}
                >
                    <Typography
                        variant="subtitle1"
                        noWrap
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.25rem' },
                            minWidth: 0,
                            flexShrink: 1,
                            color: '#e0f2fe',
                        }}
                    >
                        {selectedDate.format(dateFormat)}
                    </Typography>
                    {showAddButton && !isSelectedDateInPast && (
                        <Chip
                            label="+"
                            onClick={onNewTermin}
                            size="small"
                            sx={{
                                minWidth: 32,
                                height: 32,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                                color: '#fff',
                                flexShrink: 0,
                                ml: 1,
                                cursor: 'pointer',
                            }}
                        />
                    )}
                </Box>

                <Divider sx={{ mb: 2, borderColor: 'rgba(59, 130, 246, 0.2)' }} />

                {isSelectedDateInPast && (
                    <Box sx={{ mb: 2, p: 1.5, borderRadius: '16px', bgcolor: 'rgba(59,130,246,0.04)' }}>
                        <Typography variant="body2" color="#93c5fd">
                            Termine in der Vergangenheit können nicht erstellt werden
                        </Typography>
                    </Box>
                )}

                {termineForSelectedDate.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant="body2" color="#93c5fd">
                            Keine Termine an diesem Tag
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {termineForSelectedDate
                            .sort((a, b) => a.startzeit.localeCompare(b.startzeit))
                            .map((termin) => (
                                <Paper
                                    key={termin.id}
                                    sx={{
                                        p: 2,
                                        cursor: 'pointer',
                                        border: '2px solid',
                                        borderColor: nimmtTeil(termin) ? '#8b5cf6' : '#1e3a8a',
                                        bgcolor: nimmtTeil(termin) ? 'rgba(139, 92, 246, 0.1)' : 'rgba(59, 130, 246, 0.1)',
                                        borderRadius: '16px',
                                    }}
                                    onClick={() => onTerminClick(termin)}
                                >
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                        <Typography variant="h6" color="#3b82f6">
                                            {termin.startzeit.substring(0, 5)} Uhr
                                        </Typography>
                                        {nimmtTeil(termin) && (
                                            <CheckCircleIcon sx={{ color: '#8b5cf6' }} />
                                        )}
                                    </Box>
                                    <Typography variant="body2" color="#93c5fd" gutterBottom>
                                        {termin.ersteller_vname} {termin.ersteller_nname}
                                    </Typography>
                                    {termin.notiz && (
                                        <Typography variant="body2" color="#93c5fd" sx={{ mb: 1 }}>
                                            {termin.notiz}
                                        </Typography>
                                    )}
                                    {termin.teilnehmer.length > 0 && (
                                        <Box display="flex" alignItems="center" gap={1} mt={2}>
                                            <Typography variant="caption" color="#93c5fd">
                                                Teilnehmer:
                                            </Typography>
                                            <AvatarGroup
                                                max={4}
                                                sx={{
                                                    '& .MuiAvatar-root': {
                                                        width: 28,
                                                        height: 28,
                                                        fontSize: '0.75rem',
                                                        bgcolor: '#1e3a8a',
                                                        color: '#e0f2fe',
                                                    },
                                                }}
                                            >
                                                {termin.teilnehmer.some(t => t.status !== "absage") ? (
                                                    termin.teilnehmer.map((t) => (
                                                        t.status !== "absage" && (
                                                            < Avatar key={t.id} > {t.name.charAt(0)}</Avatar>
                                                        )
                                                    ))
                                                ) : (
                                                    <Typography variant="caption" color="#93c5fd">
                                                        Noch keine Zusagen
                                                    </Typography>
                                                )}
                                            </AvatarGroup>
                                        </Box>
                                    )}
                                </Paper>
                            ))}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}

export default TerminListe;
